module.exports = __webpack_public_path__ + "images/category_lp/common/icon-cheapest-price_04c37b5be039274834fe19794331d620.png";